<style>
  .line-height20{
    line-height: 19px;
  }
  
</style>
<template>
  <div class="revisePass-box">
    <div class="shade-box ">
      <div class="shade-content position-top">
        <p class="dialog-title-bg line-height20">修改密码
          <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="cancelRevisePass('revisePassForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="reviseForm" ref="revisePassForm" label-width="100px" class="demo-ruleForm" :rules="$rules">
            <el-form-item label="旧密码" prop="userPassword">
              <el-input class="paddingStyle" v-model="reviseForm.userPassword" placeholder="请输入旧密码" maxlength="20" ref="passInput" type="password" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPass">
              <el-input class="paddingStyle" v-model="reviseForm.newPass" placeholder="请输入新密码" maxlength="20" type="password" auto-complete="off" @blur='blurNewPass'></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="enterPass" :rules="[{required: true, message: '请再次输入新密码', trigger: 'blur'}, {validator: (rule, value, callback)=>{validateEnterPass(rule, value, callback)}, trigger: ['blur']}]">
              <el-input class="paddingStyle" v-model="reviseForm.enterPass" placeholder="请再次输入新密码" maxlength="20" type="password" auto-complete="off" @keyup.enter.native='submitForm("revisePaddForm")'></el-input>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('revisePaddForm')" :disabled="disabled">确认修改</el-button>
              <el-button @click="cancelRevisePass('revisePassForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  name: "revisePass",
  data(){
    return{
      reviseForm: {
        disabled: false,
        userId: '',
        userPassword: '',
        newPass: '',
        enterPass: ''
      },
    };
  },
  created(){
    this.$nextTick(function(){
      this.$refs.passInput.focus();
    });
    this.userId = JSON.parse(localStorage.getItem("USER")).userId;
  },
  methods: {
    // passWord(pass){
    //   let str = '';
    //   let value = this.reviseForm[pass];
    //   str += value.substr(value.length-1,1); //获取最后一个字符加到到str,因为除了最后一个字符，其他的已经为*
    //   this.reviseForm[pass] = value.replace(/./g,'*'); //输入框内容全部变为*
    // },
    blurNewPass(){
      if(this.reviseForm.enterPass){
        this.$refs.revisePassForm.validateField('enterPass');
      }
    },
    validateEnterPass(rule, value, callback){
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.reviseForm.newPass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
    submitForm(formName){//修改
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          let data = {
            "userId": this.userId,
            "userOldPassword": this.$md5(this.$md5(this.reviseForm.userPassword)),
            "userNewPassword": this.$md5(this.$md5(this.reviseForm.newPass)),
            "userConfirmPwd": this.$md5(this.$md5(this.reviseForm.enterPass))
          }
          api.updatePassword({data:data}).then(res => {
            this.disabled = false;
            if(res.status == 'success'){
              this.$message.success(res.msg);
              this.cancelRevisePass('revisePaddForm');
            }
          })
        } else {
          return false;
        }
      });
    },
    cancelRevisePass(formName){//取消修改
      this.$refs[formName].resetFields();
      this.$emit('colsePass')
    }
  },
  components: {
   
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/layout/revisePass.vue